import React from 'react';
import PropTypes from 'prop-types';
import { Icon, List, Badge, Collapse } from '@pella/sash-framework';
import { CTA } from '../../..';

const MobileMegaMenu = ({ data, onBackClick }) => {
	if (!data?.sortable?.[0]) return null;

	return (
		<div className={`mobileChildMenu absolute -right-[320px] top-0 flex h-full w-full flex-col overflow-hidden overflow-y-auto bg-white transition-all duration-300`}>
			<button
				className='mobileChildMenu-backBtn flex w-full items-center border-y border-y-gray-10 bg-gray-3 px-4 py-1'
				onClick={onBackClick}
			>
				<Icon
					name='keyboard_arrow_left'
					size={24}
				/>
				<span className='ml-1 text-sm font-semibold uppercase'>Main Menu</span>
			</button>

			{data.sortable?.length > 1 && data.heading && <p className='border-b border-b-gray-10 px-4 py-3 text-lg font-semibold'>{data.heading}</p>}

			<List
				bullets='none'
				className='mobileChildMenu-navList'
			>
				{data.sortable.map((category, index) => (
					<li key={index}>
						<Collapse
							className={data.sortable.length > 1 ? '!border-b-gray-10' : '!border-b-0'}
							isOpen={data.sortable.length === 1}
						>
							<Collapse.Trigger
								renderAs='p'
								className={`bg-white !py-3 px-4 font-semibold text-secondary-dark shadow-[0_4px_6px_rgba(0,0,0,0.05)] [&+div]:px-4 ${data.sortable.length === 1 ? 'text-lg [&_button]:pointer-events-none [&_span>span]:hidden' : 'text-base'}`}
							>
								{category.heading}
							</Collapse.Trigger>

							<Collapse.Content>
								{category.by_type?.[0] &&
									category.by_type.map((item, index) => (
										<List
											key={index}
											bullets='none'
											className={index > 0 ? 'mt-4 border-t border-t-gray-10 pt-4' : ''}
										>
											<li className='childMenu-typeHeading text-sm text-gray-50'>{item.heading}</li>

											{item.ctas?.[0] &&
												item.ctas.map((cta, index) => (
													<li key={index}>
														<CTA
															data={cta.cta[0]}
															className='flex items-center py-3 text-base no-underline'
														>
															<span className='font-semibold'>{cta.cta[0].cta_title}</span>
															{cta.flag && (
																<Badge
																	color='light-gray'
																	style={{ backgroundColor: cta.flag_hex_value, color: cta.text_hex_value }}
																	variant='pill'
																	className='ml-2 !text-xs !font-normal'
																	size='sm'
																>
																	{cta.material_symbol && <Icon size={10} className='mr-1' name={cta.material_symbol} />}
																	{cta.flag}
																</Badge>
															)}
														</CTA>
													</li>
												))}
										</List>
									))}

								{category.cta?.[0] && (
									<List
										key={index}
										bullets='none'
									>
										{category.cta.map((cta, index) => (
											<li
												key={index}
												className='mt-3 border-t border-t-gray-10 pt-2'
											>
												<CTA
													data={cta}
													className='py-3 !text-left font-semibold'
												/>
											</li>
										))}
									</List>
								)}
							</Collapse.Content>
						</Collapse>
					</li>
				))}
			</List>

			{data.cta?.[0] && (
				<div className='mt-auto'>
					<CTA
						data={data.cta[0]}
						className='flex items-center justify-between bg-primary px-4 pb-6 pt-3 text-white'
					>
						<span className='flex-1 pr-2 text-xs font-semibold !leading-snug underline decoration-white decoration-1'>{data.cta[0].cta_title}</span>
						<Icon
							name='arrow_forward'
							size={16}
						/>
					</CTA>
				</div>
			)}
		</div>
	);
};

MobileMegaMenu.propTypes = {
	data: PropTypes.object,
	onBackClick: PropTypes.func,
};

export default MobileMegaMenu;
